import React, { Fragment } from 'react';
import ReactPlayer from 'react-player';
import heroVideo from './3.mp4';
import HeroOverlay from './HeroOverlay';
const Hero = () => {
  return (
    <Fragment>
      <HeroOverlay>
        <ReactPlayer
          url={heroVideo}
          playing
          loop
          muted
          width="100%"
          height="100%"
        />
      </HeroOverlay>
    </Fragment>
  );
};

export default Hero;
